import { combineReducers } from "redux";

import { unApproveBookingListingDetails } from "./reducer.bookingListing"
const unApproveBookingListingReducers = combineReducers({
  unApproveBookingListingDetails
})
export default unApproveBookingListingReducers;
